module.exports = __webpack_public_path__ + "static/media/diamond_cash.ecf53038.png";